import { CheckboxColumn } from "./CheckboxColumn/CheckboxColumn";
import { EnterValueColumn } from "./EnterValueColumn/EnterValueColumn";
import { ListColumn } from "./ListColumn/ListColumn";
import { SearchColumn } from "./SearchColumn/SearchColumn";

import type { Column } from "./types";

interface ColumnComponentProps {
  column: Column;
  onSelect: (value: string) => void;
  selectedValue?: string;
  onSearch?: (searchTerm: string) => void;
  searchTerm?: string;
}

// Component to render the appropriate column type
export function ColumnContent({
  column,
  onSelect,
  selectedValue,
  onSearch,
  searchTerm,
}: ColumnComponentProps) {
  switch (column.type) {
    case "checkbox":
      return (
        <CheckboxColumn
          column={column}
          onSearch={onSearch}
          onSelect={onSelect}
          searchTerm={searchTerm}
          selectedValue={selectedValue}
        />
      );
    case "list":
      return <ListColumn column={column} onSelect={onSelect} selectedValue={selectedValue} />;
    case "search":
      return (
        <SearchColumn
          column={column}
          onSearch={onSearch}
          onSelect={onSelect}
          searchTerm={searchTerm}
          selectedValue={selectedValue}
        />
      );
    case "enter-value":
      return <EnterValueColumn column={column} onSelect={onSelect} selectedValue={selectedValue} />;
    default:
      return null;
  }
}
